import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import RegisterRentalOperator from "rental-operator/redux/Reducers/RegisterRentalOperatorReducer";
import VerificationOtpReducer from "rental-operator/redux/Reducers/VerifyOtpReducer";
import FaqOperatorReducer from "rental-operator/redux/Reducers/FaqReducer";
import CurrentLocationReducer from "Rental-Customer/Redux/Reducers/CurrentLocationReducer";
import SelfGuidedTripsReducer from "Rental-Customer/Redux/Reducers/SelfGuidedTripsReducer";
import SelfGuidedTripDetailReducer from "Rental-Customer/Redux/Reducers/SelfGuidedTripDetailReducer";
import HeaderReducer from "Rental-Customer/Redux/Reducers/HeaderReducer";
import FooterReducer from "Rental-Customer/Redux/Reducers/FooterReducer";
import FaqCutomerReducer from "Rental-Customer/Redux/Reducers/FaqReducer";
import RideNearYouReducer from "Rental-Customer/Redux/Reducers/RideNearYouReducer";
import TourCustomerLocationReducer from "Tour-Customer/Redux/Reducer/LocationReducer";
import GetGstDetailReducer from "Rental-Customer/Redux/Reducers/GstReducer";
import PincodeReducer from "Rental-Customer/Redux/Reducers/PincodeReducer";
import SearchCustomerReducer from "Rental-Customer/Redux/Reducers/SearchCustomerReducer";
import CustomerReviewsReducer from "Rental-Customer/Redux/Reducers/CustomerReviewsReducer";
import CustomerTokenReducer from "Rental-Customer/Redux/Reducers/CustomerTokenReducer";
import BookingDetailReducer from "Rental-Customer/Redux/Reducers/BookingDetailReducer";
import BookingRiderDetails from "Rental-Customer/Redux/Reducers/BookingRiderDetailsReducer";
import AddReviewDataReducer from "Rental-Customer/Redux/Reducers/AddReviewReducer";
import AddressReducer from "Rental-Customer/Redux/Reducers/AddressReducer";
import AddToCardBooking from "Rental-Customer/Redux/Reducers/AddToCartReducer";
import CheckRideroutReducer from "Rental-Customer/Redux/Reducers/CheckRideroutReducer";
import RecommendedBikesReducer from "Rental-Customer/Redux/Reducers/RecommendedBikesReducer";
import VerificationMailOtpReducer from "rental-operator/redux/Reducers/VerifyMailOtpReducer";
import OperatorReducer from "Rental-Customer/Redux/Reducers/OperatorReducer";
import LandingReducer from "Rental-Customer/Redux/Reducers/LandingReducer";
import RentalPartnerDetailReducer from "Rental-Customer/Redux/Reducers/RentalPartnerDetailReducer";
import AllReviewReducer from "Rental-Customer/Redux/Reducers/AllReviewReducer";
import CancelRiderReducer from "Rental-Customer/Redux/Reducers/CancelRiderReducer";
import CancelBookingReducer from "Rental-Customer/Redux/Reducers/CancelBookingReducer";
import UpdateAlternativeBookingReducer from "Rental-Customer/Redux/Reducers/UpdateAlternativeBookingReducer";
import CanellationPolicyReducer from "Rental-Customer/Redux/Reducers/CanellationPolicyReducer";
import AlternativeBikeReducer from "Rental-Customer/Redux/Reducers/AlternativeBikeReducer";
import PreOnBoardingReducer from "rental-operator/redux/Reducers/PreOnboardingReducer";
import NewRegistrationReducer from "Rental-admin/Redux/Reducers/NewRegistrationReducer";
import LoginReducer from "Rental-admin/Redux/Reducers/LoginReducer";
import AzureUploadReducer from "rental-operator/redux/Reducers/UploadFileAzureReducer";
import NewRegistrationDetailReducer from "Rental-admin/Redux/Reducers/NewRegistrationDetailReducer";
import AEMApiReducer from "Rental-Customer/Redux/Reducers/AEMApiReducer";
import common from "./reducer";
import FirstTimeApprovalDetailsReducer from "Rental-admin/Redux/Reducers/FirstTimeApprovalDetailsReducer";
import ManageMotorCycleReducer from "rental-operator/redux/Reducers/ManageMotorcycleReducer";

import LIstOfFleetReducer from "Rental-admin/Redux/Reducers/LIstOfFleetReducer";
import ListOfToursReducer from "Rental-admin/Redux/Reducers/ListOfToursReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import {
  CityReducer,
  StateReducer,
  CountryReducer,
} from "rental-operator/redux/Reducers/StateCityReducer";
import OperatorLoginReducer from "rental-operator/redux/Reducers/OperatorLoginReducer";
import AwaitedListReducer from "Rental-admin/Redux/Reducers/AwaitedListReducer";
import ContenApproveFleetReducer from "Rental-admin/Redux/Reducers/ContenApproveFleetReducer";
import ContractDetailReducer from "Rental-admin/Redux/Reducers/ContractDetailReducer";
import liveFleetReducer from "rental-operator/redux/Reducers/LiveFleetReducer";
import RatingReviewReducer from "rental-operator/redux/Reducers/RatingReviewReducer";

import ContractReducer from "Rental-admin/Redux/Reducers/ContractReducer";
import ContractVerificationReducer from "rental-operator/redux/Reducers/ContractVerificationReducer";
import AccountInfoReducer from "rental-operator/redux/Reducers/AccountInfoReducer";
import BookingListReducer from "Rental-admin/Redux/Reducers/BookingReducer";

import ValueAddedServicesListReducer from "rental-operator/redux/Reducers/ValueAddedServicesListReducer";
import OperatorTransactionListReducer from "rental-operator/redux/Reducers/OperatorTransactionListReducer";
import OperatorBookingListReducer from "rental-operator/redux/Reducers/BookingReducer";
import PaymentsListReducer from "Rental-admin/Redux/Reducers/PaymentsListReducer";
import LiveOperatorListReducer from "Rental-admin/Redux/Reducers/LiveOperatorListReducer";
import RiderDocumentReducer from "rental-operator/redux/Reducers/RiderDocumentReducer";
import AccountDetailReducer from "Rental-admin/Redux/Reducers/AccountDetailReducer";
import MyprofileReducer from "rental-operator/redux/Reducers/MyprofileReducer";
import UpdateApprovalDetailReducer from "Rental-admin/Redux/Reducers/UpdateApprovalDetailReducer";
import AdminProfileReducer from "Rental-admin/Redux/Reducers/AdminProfileReducer";
import BookingReducer from "Rental-admin/Redux/Reducers/BookingReducer";
import AdminBookingDetailReducer from "Rental-admin/Redux/Reducers/BookingDetailReducer";
import OperatorTermsAndPoliciesReducer from "rental-operator/redux/Reducers/TermsAndPoliciesReducer";
import OperatorLocationReducer from "rental-operator/redux/Reducers/LocationReducer";
import OperatorModelReducer from "rental-operator/redux/Reducers/ModelReducer";
import CompagainReducer from "Rental-admin/Redux/Reducers/CampaignReducer";
import OperatorSubstitueReducer from "rental-operator/redux/Reducers/SubstitueReducer";
import UpdateApprovalReducer from "Rental-admin/Redux/Reducers/UpdateApprovalReducer";
import CustomerReducer from "Rental-admin/Redux/Reducers/CustomerReducer";
import TransactionDetailsReducer from "rental-operator/redux/Reducers/TransactionDetailsReducer";
import PaymentDetailsReducer from "Rental-admin/Redux/Reducers/PaymentDetailsReducer";
import ManageAccountUserReducer from "rental-operator/redux/Reducers/ManageAccountUserReducer";
import RentalOperatorReviewReducer from "Rental-admin/Redux/Reducers/RentalOperatorReviewReducer";
import NotificationReducer from "./CommonReducers/NotificationReducer";

import FleetDetailReducer from "Rental-admin/Redux/Reducers/FleetDetailReducer";
import MangeUserReducer from "Rental-admin/Redux/Reducers/MangeUserReducer";
import MotorcycleModelReducer from "Rental-admin/Redux/Reducers/MotorcycleModelReducer";

import OutOfStockReducer from "Rental-Customer/Redux/Reducers/OutOfStockReducer";
import { checkTokenExpirationMiddleware } from "./Middleware";
import ManageToursReducer from "Tour-Operator/redux/Reducers/manageTourReducer";
import ManageRidesReducer from "Tour-Operator/redux/Reducers/manageRidesReducer";
import TourExploreReducer from "Tour-Customer/Redux/Reducer/TourExploreReducer";
import ManageLeadsReducer from "Tour-Operator/redux/Reducers/manageLeadsReducer";
import TourPartnersReducer from "Tour-Customer/Redux/Reducer/TourPartnersReducer";
import ManageTripsReducer from "Tour-Operator/redux/Reducers/ManageTripsReducer";
import ReviewsTourLandingReducer from "Tour-Customer/Redux/Reducer/TourReviewsReducer";
import CustomerDetailsReducer from "Tour-Customer/Redux/Reducer/CustomerDetailsReducer";
import TourCampaignReducers from "Tour-Admin/Redux/Reducers/TourCampaignReducers";
import TourCompareReducer from "Tour-Customer/Redux/Reducer/TourCompareReducer";
import TourBookingReducer from "Tour-Customer/Redux/Reducer/TourBookingReducer";
import TourInquiryReducer from "Tour-Customer/Redux/Reducer/TourInquiryReducer";
import LiveTourOperatorListReducers from "Tour-Admin/Redux/Reducers/LiveTourOperatorListReducers";
import TourAccountDetailReducer from "Tour-Admin/Redux/Reducers/TourAccountDetailReducer";
import UpdateApprovalTourReducer from "Tour-Admin/Redux/Reducers/UpdateApprovalTourReducer";
import OperatingToursReducer from "Tour-Admin/Redux/Reducers/OperatingToursReducer";
import OperatorFleetReducer from "Tour-Admin/Redux/Reducers/OperatorFleetReducer";
import OperatorTourDetailsReducer from "Tour-Admin/Redux/Reducers/OperatorTourDetailsReducer";
import OperatorTripDetailsReducer from "Tour-Admin/Redux/Reducers/OperatorTripDetailsReducer";
import TourAdminBookingListReducer from "Tour-Admin/Redux/Reducers/BookingListReducer";
import TourOperatorBookingListReducer from "Tour-Operator/redux/Reducers/BookingListReducer";
import OperatorFleetDetailReducer from "Tour-Admin/Redux/Reducers/OperatorFleetDetailReducer";
import TourOperatorBookingDetailReducer from "Tour-Operator/redux/Reducers/BookingDetailReducer";
import TourAwaitedListReducer from "Tour-Admin/Redux/Reducers/TourAwaitedListReducer";
import TourContractDetailReducer from "Tour-Admin/Redux/Reducers/TourContractDetailReducer";
import TourContractReducer from "Tour-Admin/Redux/Reducers/TourContractReducer";
import OperatorTourTransactionListReducer from "Tour-Admin/Redux/Reducers/OperatorTourTransactionListReducer";
import TourAddReviewDataReducer from "Tour-Customer/Redux/Reducer/TourAddReviewReducer";
import TourCustomerReviewsReducer from "Tour-Customer/Redux/Reducer/TourCustomerReviewsReducer";
import TourPartnerTransactionListReducer from "Tour-Operator/redux/Reducers/TourPartnerTransactionListReducer";
import TourTransactionDetailsReducer from "Tour-Operator/redux/Reducers/TourTransactionDetailReducer";
import TourRatingReviewsReducer from "Tour-Operator/redux/Reducers/TourRatingReviewsReducer";
import OperatorRatingReviewsReducer from "Tour-Admin/Redux/Reducers/OperatorRatingReviewsReducer";
import SubstituteReducer from "rental-operator/redux/Reducers/SubstitueReducer";
import LeadManagementReducer from "Rental-admin/Redux/Reducers/LeadManagementReducer";
import { reducerList } from "./ImportedTourReducers";
import dashboardReducer from "./Dashboard/reducer";
import TourDashboardReducer from "Tour-Admin/Redux/Dashboard/reducer";
import { leadManagement } from "Constant/RouteConstant/operatorConstant";
import countryReducer from "rental-operator/redux/Reducers/CountryReducer";
import googleReducer from "rental-operator/redux/Reducers/googleReducer";
import cityManagementReducer from "Rental-admin/Redux/Reducers/CityManagementReducer";
import enquiryManagementReducer from "Rental-admin/Redux/Reducers/EnquiryManagementReducer";
import tourLeadManagementReducer from "Tour-Admin/Redux/Reducers/TourManagementReducer";

import ResourceManagementReducer from "Rental-admin/Redux/Reducers/ResourceManagementReducer";
import PersonalizedToursReducer from "Tour-Admin/Redux/Reducers/PersonalizedToursReducer";
import HomepageHeaderReducer from "Rental-admin/Redux/Reducers/HomepageHeaderReducer";
import homePageReducer from "Rental-admin/Redux/Reducers/HomePageReducer";
import guidePageReducer from "Rental-admin/Redux/Reducers/GuidePageReducer";
import ticketManagementReducer from "Rental-admin/Redux/Reducers/ticketManagementReducer";
const reducer = combineReducers({
  common,
  registerRentalOperator: RegisterRentalOperator,
  verificationOtpReducer: VerificationOtpReducer,
  currentLocationReducer: CurrentLocationReducer,
  faqOperatorReducer: FaqOperatorReducer,
  selfGuidedTripsReducer: SelfGuidedTripsReducer,
  selfGuidedTripDetailReducer: SelfGuidedTripDetailReducer,
  headerReducer: HeaderReducer,
  footerReducer: FooterReducer,
  faqCutomerReducer: FaqCutomerReducer,
  rideNearYouReducer: RideNearYouReducer,
  tourCustomerLocation: TourCustomerLocationReducer,
  getGstDetailReducer: GetGstDetailReducer,
  pincodeReducer: PincodeReducer,
  substitueReducer: SubstituteReducer,
  searchCustomerReducer: SearchCustomerReducer,
  customerReviewsReducer: CustomerReviewsReducer,
  customerTokenReducer: CustomerTokenReducer,
  BookingDetailReducer: BookingDetailReducer,
  bookingRiderDetails: BookingRiderDetails,
  AddReviewDataReducer: AddReviewDataReducer,
  addressReducer: AddressReducer,
  addToCartBooking: AddToCardBooking,
  CheckRideroutReducer: CheckRideroutReducer,
  recommendedBikesReducer: RecommendedBikesReducer,
  VerificationMailOtpReducer: VerificationMailOtpReducer,
  operatorReducer: OperatorReducer,
  landingReducer: LandingReducer,
  RentalPartnerDetailReducer: RentalPartnerDetailReducer,
  AllReviewReducer: AllReviewReducer,
  CancelRiderReducer: CancelRiderReducer,
  CancelBookingReducer: CancelBookingReducer,
  UpdateAlternativeBookingReducer: UpdateAlternativeBookingReducer,
  CanellationPolicyReducer: CanellationPolicyReducer,
  AlternativeBikeReducer: AlternativeBikeReducer,
  PreOnBoardingReducer: PreOnBoardingReducer,
  NewRegistrationReducer: NewRegistrationReducer,
  LoginReducer: LoginReducer,
  NewRegistrationDetailReducer: NewRegistrationDetailReducer,
  AEMApiReducer: AEMApiReducer,
  AzureUploadReducer: AzureUploadReducer,
  FirstTimeApprovalDetailsReducer: FirstTimeApprovalDetailsReducer,
  LIstOfFleetReducer: LIstOfFleetReducer,
  ListOfToursReducer: ListOfToursReducer,
  ContenApproveFleetReducer: ContenApproveFleetReducer,
  CountryReducer: CountryReducer,
  StateReducer: StateReducer,
  CityReducer: CityReducer,
  OperatorLoginReducer: OperatorLoginReducer,
  AwaitedListReducer: AwaitedListReducer,
  ManageMotorCycleReducer: ManageMotorCycleReducer,
  ContractReducer: ContractReducer,
  ContractVerificationReducer: ContractVerificationReducer,
  RatingReviewReducer: RatingReviewReducer,
  AccountInfoReducer: AccountInfoReducer,

  ContractDetailReducer: ContractDetailReducer,
  ValueAddedServicesListReducer: ValueAddedServicesListReducer,
  liveFleetReducer: liveFleetReducer,
  OperatorTransactionListReducer: OperatorTransactionListReducer,
  OperatorBookingListReducer: OperatorBookingListReducer,
  PaymentsListReducer: PaymentsListReducer,
  LiveOperatorListReducer: LiveOperatorListReducer,
  RiderDocumentReducer: RiderDocumentReducer,
  AccountDetailReducer: AccountDetailReducer,
  UpdateApprovalDetailReducer: UpdateApprovalDetailReducer,
  MyprofileReducer: MyprofileReducer,
  AdminProfileReducer: AdminProfileReducer,
  BookingReducer: BookingReducer,
  AdminBookingDetailReducer: AdminBookingDetailReducer,
  OperatorTermsAndPoliciesReducer: OperatorTermsAndPoliciesReducer,
  OperatorLocationReducer: OperatorLocationReducer,
  OperatorModelReducer: OperatorModelReducer,
  CompagainReducer: CompagainReducer,
  OperatorSubstitueReducer: OperatorSubstitueReducer,
  UpdateApprovalReducer: UpdateApprovalReducer,
  ManageAccountUserReducer: ManageAccountUserReducer,
  RentalOperatorReviewReducer: RentalOperatorReviewReducer,
  CustomerReducer: CustomerReducer,
  TransactionDetailsReducer: TransactionDetailsReducer,
  PaymentDetailsReducer: PaymentDetailsReducer,
  FleetDetailReducer: FleetDetailReducer,
  MangeUserReducer: MangeUserReducer,
  NotificationReducer: NotificationReducer,
  OutOfStockReducer: OutOfStockReducer,
  MotorcycleModelReducer: MotorcycleModelReducer,
  ManageToursReducer: ManageToursReducer,
  manageRidesReducer: ManageRidesReducer,
  tourExploreReducer: TourExploreReducer,
  ManageLeadsReducer: ManageLeadsReducer,
  TourPartnersReducer: TourPartnersReducer,
  ManageTripsReducer: ManageTripsReducer,
  ReviewsTourLandingReducer: ReviewsTourLandingReducer,
  CustomerDetailsReducer: CustomerDetailsReducer,
  TourCampaignReducers: TourCampaignReducers,
  TourCompareReducer: TourCompareReducer,
  TourBookingReducer: TourBookingReducer,
  TourInquiryReducer: TourInquiryReducer,
  LiveTourOperatorListReducers: LiveTourOperatorListReducers,
  TourAccountDetailReducer: TourAccountDetailReducer,
  UpdateApprovalTourReducer: UpdateApprovalTourReducer,
  OperatingToursReducer: OperatingToursReducer,
  OperatorFleetReducer: OperatorFleetReducer,
  OperatorTourDetailsReducer: OperatorTourDetailsReducer,
  OperatorTripDetailsReducer: OperatorTripDetailsReducer,
  TourAdminBookingListReducer: TourAdminBookingListReducer,
  TourOperatorBookingListReducer: TourOperatorBookingListReducer,
  OperatorFleetDetailReducer: OperatorFleetDetailReducer,
  TourOperatorBookingDetailReducer: TourOperatorBookingDetailReducer,
  TourAwaitedListReducer: TourAwaitedListReducer,
  TourContractDetailReducer: TourContractDetailReducer,
  TourContractReducer: TourContractReducer,
  OperatorTourTransactionListReducer: OperatorTourTransactionListReducer,
  TourAddReviewDataReducer: TourAddReviewDataReducer,
  TourCustomerReviewsReducer: TourCustomerReviewsReducer,
  TourPartnerTransactionListReducer: TourPartnerTransactionListReducer,
  TourTransactionDetailsReducer: TourTransactionDetailsReducer,
  TourRatingReviewsReducer: TourRatingReviewsReducer,
  OperatorRatingReviewsReducer: OperatorRatingReviewsReducer,
  DashboardReducer: dashboardReducer,
  TourDashboardReducer: TourDashboardReducer,
  LeadManagementReducer: LeadManagementReducer,
  Country: countryReducer,
  GoogleData: googleReducer,
  cityManagementReducer: cityManagementReducer,
  enquiryManagementReducer: enquiryManagementReducer,
  tourLeadManagementReducer: tourLeadManagementReducer,
  ResourceManagementReducer: ResourceManagementReducer,
  PersonalizedToursReducer: PersonalizedToursReducer,
  HomepageHeaderReducer: HomepageHeaderReducer,
  homePageReducer: homePageReducer,
  guidePageReducer: guidePageReducer,
  ticketManagementReducer: ticketManagementReducer,

  ...reducerList,
});
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["OperatorLoginReducer", "LoginReducer"],
};

const persistedReducer = persistReducer(persistConfig, reducer);
const middleware = [thunk, checkTokenExpirationMiddleware];
let composeEnhancers;
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  // dev code
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
} else {
  composeEnhancers = compose;
}
const store = createStore(
  persistedReducer,
  /* preloadedState, */ composeEnhancers(applyMiddleware(...middleware))
);

const persistor = persistStore(store);

export { store, persistor };
